
<script>
import { dataToFormData } from '@/utils/helpers'
import { RexInput } from '@/components/views/rexFieldsV2'

export default {
  name: 'login',
  components: {
    RexInput
  },
  metaInfo: {
    title: 'Авторизация'
  },
  computed: {
    form() {
      return this.$store.getters['account/getLoginForm']
    },
    isFormValid() {
      return this.$store.getters['account/isFormValid']
    },
    isLoading() {
      return this.$store.getters['account/isLoading']
    }
  },
  methods: {
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('account/login', dataToFormData({
            ...this.form
          }))
        }
      })
    },
  }
}
</script>

<template>
  <div class="app-login-page">
    <div class="app-login-page__card">
      <div
        class="app-login-page__form"
      >
        <form>
          <rex-input
            label="Логин"
            name="login"
            store-module="account"
            getter="getFormField"
            setter="setFormField"
            target="loginForm.login"
            :is-disabled="isLoading"
            :validate="{
              required: true
            }"
          />
          <rex-input
            label="Пароль"
            name="password"
            type="password"
            store-module="account"
            getter="getFormField"
            setter="setFormField"
            target="loginForm.password"
            :is-disabled="isLoading"
            :validate="{
              required: true
            }"
          />
          <b-button
            type="is-primary"
            class="rex-button2"
            expanded
            :disabled="isLoading"
            :loading="isLoading"
            @click="submitForm"
          >
            Войти
          </b-button>
        </form>
      </div>
    </div>
  </div>
</template>
